module.exports = __webpack_public_path__ + "img/mg.c94c7483.svg";